import * as React from "react";
import { ArrowFillDown, CheckboxChecked, CheckboxIndeterminate, CheckboxUnchecked, Close, RadioButtonChecked, RadioButtonUnchecked, StatusAlert, StatusApproved, StatusEscalated, } from "@epic-ui/icons";
import Fade from "@material-ui/core/Fade";
import { deepmerge } from "@material-ui/utils";
export var createProps = function (options) {
    if (options === void 0) { options = {}; }
    var defaultProps = {
        MuiAlert: {
            variant: "standard",
            severity: "info",
            iconMapping: {
                info: React.createElement(StatusAlert, null),
                success: React.createElement(StatusApproved, null),
                warning: React.createElement(StatusAlert, null),
                error: React.createElement(StatusEscalated, null),
            },
        },
        MuiAutocomplete: {
            popupIcon: React.createElement(ArrowFillDown, null),
        },
        MuiButton: {
            variant: "contained",
            color: "primary",
            disableElevation: true,
        },
        MuiButtonBase: {
            disableRipple: true,
        },
        MuiButtonGroup: {
            variant: "contained",
            color: "primary",
            disableRipple: true,
        },
        MuiCheckbox: {
            color: "primary",
            checkedIcon: React.createElement(CheckboxChecked, null),
            indeterminateIcon: React.createElement(CheckboxIndeterminate, null),
            icon: React.createElement(CheckboxUnchecked, null),
        },
        MuiChip: {
            deleteIcon: React.createElement(Close, null),
        },
        MuiCircularProgress: {
            thickness: 4,
        },
        MuiDialogTitle: {
            disableTypography: true,
        },
        MuiInputAdornment: {
            disableTypography: true,
        },
        MuiList: {
            disablePadding: true,
        },
        MuiLink: {
            color: "textPrimary",
            underline: "always",
        },
        MuiOutlinedInput: {
            notched: false,
        },
        MuiTextField: {
            variant: "outlined",
        },
        MuiMenu: {
            elevation: 0,
            TransitionComponent: Fade,
            PaperProps: {
                variant: "outlined",
            },
        },
        MuiPaper: {
            elevation: 0,
        },
        MuiPagination: {
            shape: "rounded",
            size: "large",
        },
        MuiSelect: {
            variant: "outlined",
            MenuProps: {
                getContentAnchorEl: null,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                },
            },
            IconComponent: ArrowFillDown,
        },
        MuiSwitch: {
            color: "primary",
        },
        MuiRadio: {
            color: "primary",
            checkedIcon: React.createElement(RadioButtonChecked, null),
            icon: React.createElement(RadioButtonUnchecked, null),
        },
        MuiTableSortLabel: {
            IconComponent: ArrowFillDown,
        },
        MuiTooltip: { placement: "top" },
    };
    return deepmerge(defaultProps, options, { clone: false });
};
//# sourceMappingURL=createProps.js.map